import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'dropdown',
    template: require('./dropdown.template.html')
})
export class DropDownComponent {
    nullValue = null;
    isLoadingItems: boolean;
    isDisabled: boolean;
    items: any[];
    originalValue: any;

    private selectedItemValue: any = null;

    get selectedItem() {
        return this.selectedItemValue;
    }
    set selectedItem(val: any) {
        this.selectedItemValue = val;
        if (this.items) {
   //         this.selectedItemChange.emit({
   //             newValue: this.selectedItem,
   //             oldValue: this.originalValue
			//});

			this.selectedItemChange.emit(val);

        }
    }

    @Input() cssClass = "";

    @Input("disabled")
    set disabledBinding(isDisabled: boolean) {
        this.isDisabled = isDisabled;
    }

    @Input("items") set itemsBinding(val: any) {
        if (val instanceof Promise) {
            this.isLoadingItems = true;
            val.then(items => {
                this.items = items;
                this.isLoadingItems = false;
            });
        } else {
            this.items = val;
        }
    }
    
    @Input("selectedItem") set selectedItemBinding(val: any) {
        this.originalValue = this.selectedItemValue;
        if (typeof val == "undefined") {
            this.selectedItemValue = this.nullValue;
            return;
        }
        this.selectedItemValue = val;
    }

    @Output("selectedItemChange") selectedItemChange = new EventEmitter();
   
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/dropdown.component.ts